<script type="text/jsx">
import { PREFIX_CLASS } from '@/utils/constants'
const PREFIX_MENU_CLASS = `${PREFIX_CLASS}menu`
export default {
  name: 'TMenuGroup',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      prefixMenuClass: PREFIX_MENU_CLASS
    }
  },
  render(h) {
    return (
      <li class={this.prefixMenuClass + '__item-group'}>
        <span class={this.prefixMenuClass + '__item-group-title'}>{this.title}</span>
        <ul>
          {this.$scopedSlots.default()}
        </ul>
      </li>
    )
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/menu/menu-group.vue